/* Gigas article link copy: confirm completed writes; retain a manual route. */
(function () {
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-article-copy]');
    if (!button || button.dataset.copyBusy === 'true') return;
    event.preventDefault();
    var box = button.closest('[data-article-share]');
    var status = box.querySelector('[data-copy-status]');
    var fallback = box.querySelector('[data-copy-fallback]');
    var input = box.querySelector('[data-copy-input]');
    button.dataset.copyBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-copied');
    status.textContent = '';
    fallback.hidden = true;
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(button.dataset.copyUrl);
      button.classList.add('is-copied');
      status.textContent = button.dataset.copySuccess;
    } catch (error) {
      status.textContent = button.dataset.copyError;
      input.value = button.dataset.copyUrl;
      fallback.hidden = false;
      input.focus();
      input.select();
    } finally {
      button.dataset.copyBusy = 'false';
      button.removeAttribute('aria-busy');
    }
  });
}());
